import { Action } from '@ngrx/store';
import { RuleModel } from '../../models/RuleModel';

export const GET_RELATED_DATASETS_SUCCESS = '[Rule] Get Related DataSets Successfully';

export class GetDataSetsSuccessAction implements Action {
  readonly type = GET_RELATED_DATASETS_SUCCESS;

  constructor(public payload: { model: string[] }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetDataSetsSuccessAction.ts